import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import { buildStorageKey } from '../storage';
var LAST_LOGIN_PROVIDER_KEY = 'last-login-provider';
var LAST_LOGIN_INFO_KEY = 'last-login-info';
var NOT_YOUR_COMPUTER_KEY = 'preference:not-your-computer';

var buildLastLoginProviderKey = function buildLastLoginProviderKey(env, provider) {
  return buildStorageKey({
    env: env,
    itemKey: LAST_LOGIN_PROVIDER_KEY,
    params: [provider]
  });
};

var buildLastLoginInfoKey = function buildLastLoginInfoKey(env, variant) {
  return buildStorageKey({
    env: env,
    itemKey: LAST_LOGIN_INFO_KEY,
    params: [variant]
  });
};

var buildNotYourComputerKey = function buildNotYourComputerKey(env, variant) {
  return buildStorageKey({
    env: env,
    itemKey: NOT_YOUR_COMPUTER_KEY,
    params: [variant]
  });
};

var DataStorage = /*#__PURE__*/_createClass(function DataStorage(env, variant, appName) {
  var _this = this;

  _classCallCheck(this, DataStorage);

  this.setLastLoginProvider = function (provider) {
    var key = buildLastLoginProviderKey(_this.env, _this.variant);

    if (provider) {
      localStorage.setItem(key, provider);
    } else {
      localStorage.removeItem(key);
    }
  };

  this.getLastLoginProvider = function () {
    return localStorage.getItem(buildLastLoginProviderKey(_this.env, _this.variant));
  };

  this.setLastUserInfo = function (info) {
    var key = buildLastLoginInfoKey(_this.env, _this.variant);

    if (info) {
      localStorage.setItem(key, JSON.stringify(info));
    } else {
      localStorage.removeItem(key);
    }
  };

  this.getLastUserInfo = function (variant) {
    try {
      var value = localStorage.getItem(buildLastLoginInfoKey(_this.env, variant));
      return value && JSON.parse(value);
    } catch (_a) {
      return null;
    }
  };

  this.setNotYourComputer = function (notYourComputer) {
    var key = buildNotYourComputerKey(_this.env, _this.variant);

    if (notYourComputer !== undefined) {
      localStorage.setItem(key, notYourComputer.toString());
    } else {
      localStorage.removeItem(key);
    }
  };

  this.getNotYourComputer = function () {
    var value = localStorage.getItem(buildNotYourComputerKey(_this.env, _this.variant));
    return value !== null ? value === 'true' : undefined;
  };

  this.env = env;
  this.variant = variant;
  this.appName = appName;
});

export { DataStorage as default };